import { useState, useCallback, useEffect } from 'react';
import { useRequest, useModel } from 'umi';
import * as apis from '@/pages/order-center-order-confirm/components/handling-service/apis';
import type { CartageChargesConfig } from '@/pages/order-center-order-confirm/components/handling-service/type';
import { EService } from '@/pages/order-center-order-confirm/components/handling-service/type';


// 确认订单-搬运服务
export default function OrderCenterSameCityHandlingService() {
  const { selectedCity } = useModel('order-center-same-city-shipping-city');
  const { selectedVehicleId, cityInfo } = useModel(
    'order-center-same-city-car-model-select'
  );
  const [service, setService] = useState<Record<string, any> | null>(null);
  const setServiceCb = useCallback((val) => {
    setService(val)
  }, []); // 搬运服务类
  const resetHandlingService = useCallback(() => {
    setServiceCb(null);
  }, [setServiceCb]);

  // 用户搬运计价结果（缓存撮合、承运两种计价结果）
  const [userCalcDetail, setUserCalcDetail] = useState<any>();
  const setUserCalcDetailCb = useCallback((val) => setUserCalcDetail(val), []);
  // 搬运平台计价结果
  const [porterageCalc, setPorterageCalc] = useState<
    Record<string, any> | undefined
  >();
  // 聚合接口 - 是否展示搬运 0不展示 1展示
  const [canPorterage, setCanPorterage] = useState<number>(1);
  const setPorterageCalcCb = useCallback((val) => {
    setPorterageCalc(val);
  }, []);

  // 搬运平台计价结果 - 传给下单接口的参数
  const [porterageCalcParams, setPorterageCalcParams] = useState<Record<
    string,
    any
  > | null>(null);
  const setPorterageCalcParamsCb = useCallback((val) => {
    setPorterageCalcParams(val);
  }, []);

  // 搬运平台说明配置
  const [cartageConfig, setCartageConfig] = useState<CartageChargesConfig>();

  const platformConfigDetailRs = useRequest(apis.porterageConfig, {
    manual: true,
    onSuccess: (rs: any) => {
      setCartageConfig(rs);
    },
  });

  const getCartageConfig = () => {
    platformConfigDetailRs.run({
      city_id: selectedCity,
      order_vehicle_id: selectedVehicleId,
    });
  };

  const setCartageConfigCb = useCallback((val) => {
    setCartageConfig(val);
  }, []);

  useEffect(() => {
    const existCar = cityInfo.vehicleItem?.find(
      (i: any) => i.orderVehicleId === selectedVehicleId
    );
    // 城市 车型 一致
    // console.log(
    //   selectedCity,
    //   selectedVehicleId,
    //   cityInfo,
    //   !!existCar,
    //   grayList[selectedCity || 0],
    //   porterageCalcParams,
    //   porterageCalc,
    //   'check vehicle'
    // );
    if (selectedCity && selectedCity === cityInfo.cityId && existCar) {
      getCartageConfig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCity, selectedVehicleId, cityInfo]);

  const clearCalcPlatformType = useCallback(() => {
    // 清空平台搬运数据和我来报价数据
    if ([EService.PLATFORMCALC, EService.OFFER].includes(service?.type)) {
      setService(null);
    }
  }, [setService, service])

  return {
    service,
    setServiceCb,
    resetHandlingService,

    userCalcDetail,
    setUserCalcDetailCb,

    porterageCalc,
    setPorterageCalcCb,

    porterageCalcParams,
    setPorterageCalcParamsCb,

    cartageConfig,
    setCartageConfigCb,
    getCartageConfig,

    canPorterage,
    setCanPorterage,
    clearCalcPlatformType,
  };
}
